/* ELARYS theme — interactions */
(function () {
  'use strict';

  /* ---- Sticky nav: solidify on scroll ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    var solidify = function () {
      if (window.scrollY > 30) header.classList.add('is-solid');
      else header.classList.remove('is-solid');
    };
    solidify();
    window.addEventListener('scroll', solidify, { passive: true });
  }

  /* ---- Mobile nav drawer ---- */
  var drawer = document.querySelector('.nav-drawer');
  var burger = document.querySelector('.header__burger');
  if (drawer && burger) {
    var openDrawer = function () {
      drawer.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    burger.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.faq__item').forEach(function (item) {
    var btn = item.querySelector('.faq__q');
    var ans = item.querySelector('.faq__a');
    if (!btn || !ans) return;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      ans.style.maxHeight = open ? ans.scrollHeight + 'px' : null;
    });
  });

  /* ---- Scroll reveal ---- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Product gallery thumbs ---- */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (mainImg && full) mainImg.src = full;
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---- Quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- Inline newsletter feedback (visual only; form still posts) ---- */
  /* Shopify handles the actual submission; we just show optimistic state if redirected back with ?customer_posted=true */
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    document.querySelectorAll('[data-newsletter-success]').forEach(function (el) {
      el.hidden = false;
    });
  }

  /* ---- Update cart count after add (works with default /cart/add form) ---- */
  document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // Allow native submit when JS unavailable; otherwise AJAX for smoother UX
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '...'; }
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (window.fbq) fbq('track','AddToCart',{content_ids:[String(item.product_id)],content_type:'product',value:(item.price/100),currency:'EUR'});
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
          if (btn) { btn.innerHTML = '✓ Added to cart'; }
          setTimeout(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } }, 1600);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          form.submit();
        });
    });
  });

  /* ---- Year in footer ---- */
  document.querySelectorAll('[data-year]').forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });
})();
